import { generatePath } from 'react-router-dom'
import { PaymentProviderOverviewKey } from '@/api/NPayments/Types/NPaymentProviderDto'
import { BooleanFilter } from '@/components/Filter/BooleanFilter'
import { CountryFilter } from '@/components/Filter/common.filter'
import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { Link } from 'components/Link'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'
import { links } from 'utils/featureToggles'

import { PaymentProviderTab } from './PaymentProviderSlug'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const getProviderConfigFilterOptions = (): FieldSettings[] => [
  {
    name: 'Name',
    label: 'Method Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
  {
    name: 'Description',
    label: 'External Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
  {
    name: 'Enabled',
    label: 'Enabled',
    filter: BooleanFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: 'Country',
    label: 'Country',
    filter: CountryFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]

export const paymentProviderColumns: GridColumn[] = [
  {
    title: 'Method Name',
    field: PaymentProviderOverviewKey.method,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem || !props.dataItem.name) {
        return <td />
      }

      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(
                links.administrationPaymentProvidersConfig.detailsUrl as string,
                {
                  id: props.dataItem.id,
                  slug: PaymentProviderTab.OPTIONS_AND_LIMIT,
                }
              ),
            }}
          >
            {props.dataItem.name}
          </Link>
        </td>
      )
    },
    show: true,
  },
  {
    title: 'External Name',
    field: PaymentProviderOverviewKey.description,
    show: true,
  },
  {
    title: 'Enabled',
    field: PaymentProviderOverviewKey.enabled,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={props.dataItem.enabled} disabled />
        </td>
      )
    },
    show: true,
  },
]

export const paymentProviderOptionsAndLimitsOptionsColumns: GridColumn[] = [
  {
    title: 'Wallet Type',
    field: PaymentProviderOverviewKey.walletType,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.walletType.name) {
        return <td />
      }
      return <td>{props.dataItem.walletType.name}</td>
    },
    show: true,
  },
  {
    title: 'Currency',
    field: PaymentProviderOverviewKey.paymentCurrency,
    show: true,
  },
  {
    title: 'Type',
    field: PaymentProviderOverviewKey.configurationType,
    show: true,
  },
  {
    title: 'Minimum',
    className: 'table-columns__number',
    field: PaymentProviderOverviewKey.minimumAmount,
    show: true,
  },
  {
    title: 'Maximum',
    className: 'table-columns__number',
    field: PaymentProviderOverviewKey.maximumAmount,
    show: true,
  },
  {
    title: 'Enabled',
    field: PaymentProviderOverviewKey.enabled,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={props.dataItem.enabled} disabled />
        </td>
      )
    },
    show: true,
  },
  {
    title: 'Maintenance',
    field: PaymentProviderOverviewKey.maintenance,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={props.dataItem.maintenance} disabled />
        </td>
      )
    },
    show: true,
  },
]
